import React from "react";
import { GoBackButton } from "../Components/GoBackButton";
import { TransferOwnership } from "./TransferOwnership";
import { RestoreCompany } from "./RestoreCompany";

export default function AdminPanel({ onHomepageClick, setFeedback, post }) {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <GoBackButton onClick={onHomepageClick} />

      {/* Header */}
      <div className="text-center mb-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Panel</h1>
        <p className="text-gray-500 text-sm">
          Restricted access — Admin operations
        </p>
      </div>

      <TransferOwnership setFeedback={setFeedback} post={post} />
      <RestoreCompany setFeedback={setFeedback} post={post} />
    </div>
  );
}
